var exports = {
  "uF": "PermissionComponents.module__stateButtonsContainer___RnlsQ1",
  "ev": "PermissionComponents.module__stateButton___RnlsQ1",
  "uz": "PermissionComponents.module__stateButtonDisabled___RnlsQ1",
  "Jj": "PermissionComponents.module__stateButtonEnabled___RnlsQ1",
  "c$": "PermissionComponents.module__stateButtonDeny___RnlsQ1",
  "D5": "PermissionComponents.module__stateButtonNeutral___RnlsQ1",
  "N$": "PermissionComponents.module__stateButtonAllow___RnlsQ1",
  "Z9": "PermissionComponents.module__stateButtonInactive___RnlsQ1",
  "Ds": "PermissionComponents.module__stateDivider___RnlsQ1",
  "oq": "PermissionComponents.module__overwriteToggle___RnlsQ1",
  "rt": "PermissionComponents.module__overwriteToggleDense___RnlsQ1",
  "HC": "PermissionComponents.module__overwriteToggleContent___RnlsQ1",
  "_O": "PermissionComponents.module__overwriteToggleTitle___RnlsQ1",
  "Jw": "PermissionComponents.module__overwriteToggleTitleEnabled___RnlsQ1",
  "Mr": "PermissionComponents.module__overwriteToggleTitleDisabled___RnlsQ1",
  "GE": "PermissionComponents.module__overwriteToggleDescription___RnlsQ1",
  "fD": "PermissionComponents.module__overwriteToggleActions___RnlsQ1",
  "Wk": "PermissionComponents.module__categoryContainer___RnlsQ1",
  "yj": "PermissionComponents.module__categoryDivider___RnlsQ1",
  "p8": "PermissionComponents.module__categoryTitle___RnlsQ1",
  "LW": "PermissionComponents.module__categoryPermissions___RnlsQ1",
  "wk": "PermissionComponents.module__categoryPermissionsDense___RnlsQ1",
  "n2": "PermissionComponents.module__categoryPermissionsGrid___RnlsQ1",
  "HF": "PermissionComponents.module__roleToggle___RnlsQ1",
  "_y": "PermissionComponents.module__roleToggleDense___RnlsQ1",
  "vx": "PermissionComponents.module__tooltipTriggerBlock___RnlsQ1",
  "RO": "PermissionComponents.module__tooltipTriggerInline___RnlsQ1",
  "Iz": "PermissionComponents.module__roleCategoryContainer___RnlsQ1",
  "mj": "PermissionComponents.module__roleCategoryDivider___RnlsQ1",
  "rh": "PermissionComponents.module__roleCategoryTitle___RnlsQ1",
  "XC": "PermissionComponents.module__roleCategoryPermissions___RnlsQ1",
  "MC": "PermissionComponents.module__roleCategoryPermissionsDense___RnlsQ1",
  "bE": "PermissionComponents.module__roleCategoryPermissionsGrid___RnlsQ1",
};

module.exports = exports;
